import { render } from "./SelectQualifications.vue?vue&type=template&id=6971a06f&scoped=true"
import script from "./SelectQualifications.vue?vue&type=script&lang=js"
export * from "./SelectQualifications.vue?vue&type=script&lang=js"

import "./SelectQualifications.vue?vue&type=style&index=0&id=6971a06f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6971a06f"]])

export default __exports__